import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DtoSamplingSurfacePoint from '../../../../dto/DtoSamplingSurfacePoint'
import { find } from 'lodash'
import SitesPoint from '../../../../../utils/mapUtils/layers/SitesPoint'
import SingleStationPoint from '../../../../../utils/mapUtils/layers/SingleStationPoint'
import PopupFactory from '../../../../../utils/mapUtils/PopupFactory'
import OSM from '../../../../../utils/mapUtils/layers/OSM'
import SiteTypes from '../../../../../utils/mapUtils/SiteTypes'
import DtoPoint from '../../../../dto/DtoPoint'
import DtoSupport from '../../../../../referential/dto/DtoSupport'
import Map from '../../../../../utils/mapUtils/Map'

class SamplingSurfacePointMapPanel extends Component {
	constructor(props) {
		super(props)
		this.state = {
			popupFilter: ['Point']
		}
	}

	getData = () => {
		if (this.props.point.xCoordinate && this.props.point.yCoordinate) {
			const layersGroup1 = [
				OSM()
			]

			const data = this.props.samplingSurfacePoints.map(samplingSurfacePoints => {
				if (samplingSurfacePoints.supportCode) {
					const support = find(this.props.supports, (o) => {
						return o.id == samplingSurfacePoints.supportCode
					})
					if (support) {
						return Object.assign({}, samplingSurfacePoints, {
							name: support.name + ' [' + samplingSurfacePoints.supportCode + ']'
						})
					}
					return samplingSurfacePoints
				}
				return samplingSurfacePoints
			})

			const saplingSurfacePoints = (() => {
				return SitesPoint({
					site: data,
					type: SiteTypes.SAMPLING_SURFACE_POINT,
					popup: PopupFactory.popupSamplingSurfacePoint
				})
			})()

			const mapConf = {
				size: this.props.height,
				center: [this.props.point.xCoordinate, this.props.point.yCoordinate],
				zoom: 18
			}
			const stationPoint = SingleStationPoint({
				site: this.props.point,
				type: SiteTypes[this.props.point.typeParameter]
			})
			const layers = layersGroup1.concat(saplingSurfacePoints, [stationPoint])
			return [mapConf, layers]
		}
		return ['', '']
	}

	render() {
		if (this.props.samplingSurfacePoints.length) {
			const data = this.getData()
			const popupProps = {
				filters: this.state.popupFilter
			}
			return (
				<div className={ 'row no-margin' }>
					<div className='col s12 no-padding'>
						<Map mapConf={ data[0] } layers={ data[1] } popupProps={ popupProps }/>
					</div>
				</div>
			)
		}
		return null
	}
}

SamplingSurfacePointMapPanel.propTypes = {
	samplingSurfacePoints: PropTypes.arrayOf(PropTypes.objectOf(DtoSamplingSurfacePoint)),
	point: PropTypes.objectOf(DtoPoint),
	supports: PropTypes.arrayOf(PropTypes.objectOf(DtoSupport)),
	height: PropTypes.number
}

SamplingSurfacePointMapPanel.defaultProps = {
	height: 400
}
const mapStateToProps = store => {
	return {
		samplingSurfacePoints: store.PointReducer.samplingSurfacePoints,
		supports: store.ReferentialReducer.supports,
		point: store.PointReducer.point
	}
}

export default connect(mapStateToProps)(SamplingSurfacePointMapPanel)



// WEBPACK FOOTER //
// ./src/point/components/pointType/quality/samplingSurfacePoint/SamplingSurfacePointMapPanel.js